import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import { Col } from "reactstrap";
import { Sliders } from "react-feather";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Image } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import { showButtonforPath } from "../../../Data/SideMenu/RouteMapping";
import SharedDataContext from "../../../_helper/SharedData";
import { megaLogo } from "../../../api";
const Leftbar = () => {
  const history = useNavigate();
  const location = useLocation()
  const { toggleSidebar } = useContext(CustomizerContext);
  const { pageNumber } = useContext(SharedDataContext);
  const [sidebartoggle, setSidebartoggle] = useState(true);
  const width = useWindowSize();

  const currentPath = window.location.pathname;

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize(window.innerWidth);
        if (window.innerWidth <= 991) {
          toggleSidebar(true);
          document.querySelector(".page-wrapper").className =
            "page-wrapper compact-wrapper";
        } else {
          toggleSidebar(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  const responsive_openCloseSidebar = (toggle) => {
    if (width <= 991) {
      document.querySelector(".page-header").className = "page-header";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
    } else {
      if (toggle) {
        setSidebartoggle(!toggle);
        document.querySelector(".page-header").className =
          "page-header close_icon";
        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper close_icon ";
        document
          .querySelector(".mega-menu-container")
          .classList.remove("d-block");
      } else {
        setSidebartoggle(!toggle);
        document.querySelector(".page-header").className = "page-header";
        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper ";
      }
    }
  };

  const backPath = showButtonforPath.find((element) =>
    currentPath.includes(element.value)
  );

  return (
    <Fragment>
      <Col className="header-logo-wrapper col p-0" id="out_side_click">
        <div className="logo-wrapper">
          <Link
            to={`${process.env.PUBLIC_URL}/${localStorage.getItem("homePage")}`}
          >
            <Image
              attrImage={{
                className: "img-fluid for-light",
                src: megaLogo,
                alt: "",
              }}
            />
            <Image
              attrImage={{
                className: "img-fluid for-dark",
                src: megaLogo,
                alt: "",
              }}
            />
          </Link>
        </div>
        <div
          className="toggle-sidebar"
          onClick={() => responsive_openCloseSidebar(sidebartoggle)}
          style={
            window.innerWidth <= 991
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <Sliders
            className="status_toggle middle sidebar-toggle"
            id="sidebar-toggle"
          />
        </div>
        <div
          className="go-previous-page"
          style={backPath ? { display: "block" } : { display: "none" }}
        >
          {backPath?.url == location.state?.previousUrl ? (<Link
            to={`${process.env.PUBLIC_URL}${backPath?.url}`}
            state={{ pageNumber, filterdata: location.state?.filterdata , searchdata: location.state?.searchdata   }}>
            <i className="fa fa-angle-left"></i> Back
          </Link>) : (<Link
            onClick={() => history(-1)}
          >
            <i className="fa fa-angle-left"></i> Back
          </Link>)}
        </div>
      </Col>
    </Fragment>
  );
};

export default Leftbar;
